import * as React from 'react';
import { useAccountDropdownContext } from './AccountDropdownProvider';
import { useAccountDropdownBundle } from 'src/providers/PantherLocalizationProvider';
import {
  findSelectedAccountSwitcherAccount,
  updateMarketplaceLabelWithRetailerName,
} from './accountHelper';
import {
  AccountDropdownTriggerCommon,
  AccountDropdownTriggerProps,
  getAccountTypeLabel,
} from './AccountDropdownTriggerCommon';
import { useIsFeatureEnabled } from 'src/commons/hooks';
import { WeblabedFeatures } from 'src/commons/constants';
import { AdvertisingAccountType } from '@amzn/aac-chrome-internal-api';

export const IA2AccountDropdownTrigger: React.FC<
  AccountDropdownTriggerProps
> = ({ handleToggle, isOpen }) => {
  const {
    currentAccountName,
    currentAccountType,
    currentMarketplaceId,
    currentEntityId,
    accounts,
    loadingStatus,
    accountCounter,
    retailerName,
  } = useAccountDropdownContext();
  const bundle = useAccountDropdownBundle();
  const isMagellanEnabled = useIsFeatureEnabled(
    WeblabedFeatures.MAGELLAN_RETAILER_HEADER,
  );
  if (loadingStatus === 'success' && accountCounter === 0) return null;
  const selectedAccount =
    accounts &&
    findSelectedAccountSwitcherAccount(
      currentEntityId,
      accounts.map((accountGroup) => accountGroup.accounts).flat(),
    );
  const accountName = selectedAccount?.label || currentAccountName;
  const isTriggerEnabled = loadingStatus !== 'loading';

  const accountTypeAndMarketplaceLabel = getAccountTypeLabel({
    accounts,
    currentEntityId,
    currentAccountType,
    currentMarketplaceId,
    bundle,
  });

  const marketplaceLabel =
    isMagellanEnabled &&
    !!retailerName &&
    currentAccountType === AdvertisingAccountType.SPONSORED_ADS
      ? updateMarketplaceLabelWithRetailerName(
          accountTypeAndMarketplaceLabel,
          retailerName,
        )
      : accountTypeAndMarketplaceLabel;

  const allAccountsLabel = bundle.getMessage(
    'account-switcher-all-accounts-label',
  );

  return (
    <AccountDropdownTriggerCommon
      accountName={accountName}
      marketplaceLabel={marketplaceLabel}
      allAccountsLabel={allAccountsLabel}
      isTriggerEnabled={isTriggerEnabled}
      isOpen={isOpen}
      handleToggle={handleToggle}
    />
  );
};
